import React, { useState, useEffect, useContext, Fragment, useRef } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { useParams } from 'react-router-dom';
import 'react-times/css/classic/default.css';
import Images from 'assets/images/imageData';
import TableSection from 'components/sales/tableSection/tableSection';
import "./task.css";
import { toast } from 'react-toastify';

const styles = {
    fontFamily: "sans-serif",
    width: "500px",
  
    border: "1px solid #eee",
    background: "#f3f3f3",
    padding: "25px",
    margin: "20px"
  };
  

const TakeTest = ({
    match,
    history,
    getLevelQuestionssByRoleAndLevel,
    levelQuestions,
    submitAssessmentTest
}) => { 
    const { id } = useParams();
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [questionData, setQuestionData] = useState([]);
    const [roleId, setRoleId] = useState();
    const [inputList, setInputList] = useState([]);
    const Ref = useRef(null);
    const [startTime, setStartTime] = useState('00:00:00');
    const [totalTime, setTotalTime] = useState(0);
    const [levelName, setLevelName] = useState('');

    console.log('PAGE::TAKE TEST');

    useEffect(() => {
      const isTrue = window.confirm('Are you sure to start test ?');
      if(isTrue === false) {
         window.history.back();
      }
    },[]);
    
    useEffect(() => {
      setTimeout(() => {
        setIsLoading(true);
        (async () => {
          if(localStorage.getItem('roles')){
            const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
            setRoleId(roles);
          }
        })();
        setIsLoading(false);
      }, 1000);
    }, []);


    //Timer Start
    const [timer, setTimer] = useState('00:00:01');
    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / 1000 / 60 / 60) % 24);
        return {
            total, hours, minutes, seconds
        };
    }
    
    const startTimer = (e) => {
        let { total, hours, minutes, seconds } = getTimeRemaining(e);
        //console.log(total + ' ' + hours + ' ' + minutes + ' ' + seconds);
        if (total >= 0) {
            setTimer(
                (hours > 9 ? hours : '0' + hours) + ':' +
                (minutes > 9 ? minutes : '0' + minutes) + ':'
                + (seconds > 9 ? seconds : '0' + seconds)
            );
        }
    }
  
    const clearTimer = (e) => {
        //setTimer(e);
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000)
        Ref.current = id;
    }
  
    const getDeadTime = (totalTime) => { 
        let deadline = new Date();
        deadline.setMinutes(deadline.getMinutes() + totalTime);
        return deadline;
    }

    useEffect(() => {
        clearTimer(getDeadTime(totalTime));
    }, [totalTime]);

    // Timer End

    useEffect(() => {
       if(getLevelQuestionssByRoleAndLevel !== undefined && roleId) {
        (async () => {
          setIsLoading(true);
          const res = await getLevelQuestionssByRoleAndLevel(roleId,match.params.id);
          if(res.length > 0) {
            setTotalTime(res.length);
          } else {
            setTotalTime(0);
          }
          setIsLoading(false);
        })();  
       }
    },[getLevelQuestionssByRoleAndLevel,roleId,match.params.id]);

    useEffect(() => {
      if(levelQuestions && levelQuestions !== undefined) {
        setQuestionData(levelQuestions);
        if(levelQuestions && levelQuestions?.length > 0) {
          const list = [...inputList];
          for(var i=0; i<levelQuestions?.length; i++) {
            if(i === 0) {
              setLevelName(levelQuestions[0]['level_name']);
            }
            list[i] = {question_id:levelQuestions[i]['id'],question_label:'question_'+(i+1),checked_option:''};
          }
          setInputList([...list]);
         }
      }
    },[levelQuestions]);

    const handleTestSubmit = async (isTrue) => {
      if(isTrue === true) {
        const payload = {
          data: inputList,
          level_id: match.params.id
        }
        setIsLoading(true);
        const res = await submitAssessmentTest(payload);
        console.log(res);
        if(res == true) {
            toast.success('Assesment Submitted.');
            setIsLoading(false);
            window.history.back();
        } else {
          setIsLoading(false);
          toast.error('Someting went wrong, please try again.');
        } 
      }
    }

    const handleCheckBoxClick = (index,label,value) => {
       //console.log('Index ' + index + ' Label ' + label + ' Value ' + value);
       const list = [...inputList];
       list[index]['checked_option'] = value; 
       setInputList([...list]);
    }

    useEffect(() => {
       if(timer == '00:00:30') {
           toast.info('Remaining Time : 30 Seconds Only');
       }
       if(timer == '00:00:00') {
        //handleTestSubmit(true);
       }
    },[timer]);

    console.log(inputList);

    return(
        <Layout
          title={localization.levelTest}
          isGoback
          isLoading={isLoading}
          linkUrl={`${baseUrl}/training-levels`}
        >
        <div className="container-fluid">
         <div className="card">
          {questionData && questionData?.length > 0 ? 
          (  
          <div className='card-header h5'>{levelName} <span className='timer'> Time : {timer}</span></div>
          ): 
          <div className='card-header h5'>No Questions Found</div>
          }
          <div className="card-body">
          {/* Question Group Start */}
          {questionData && questionData?.length > 0 && questionData.map((value,index) => {
            return (
              <div className='q-formatter' key={index}>
                <p className='question-format'>
                <span><b>Question {index+1} : <span className='sp-brown'>({value['topic']})</span> -</b></span>
                <span> {value['question']}</span> 
                </p>
                <div className='row checkBox-items'>
                  <div class="col-md-6 form-check pd-10">
                    <input class="form-check-input radio-size" type="radio" name={`question_${index+1}`} id={`question_${value['id']}`} value="1" onChange={() => handleCheckBoxClick(index,"question_"+value['id'],1)} />
                    <label class="form-check-label" for={`question_${index+1}`}>
                      <b>A:</b> {value['option_1']}
                    </label>
                  </div>
                  <div class="col-md-6 form-check pd-10">
                    <input class="form-check-input radio-size" type="radio" name={`question_${index+1}`} id={`question_${value['id']}`} value="2" onChange={() => handleCheckBoxClick(index,"question_"+value['id'],2)} />
                    <label class="form-check-label" for="flexRadioCheckedDisabled">
                    <b>B:</b> {value['option_2']}
                    </label>
                  </div>
                  <div class="col-md-6 form-check pd-10">
                    <input class="form-check-input radio-size" type="radio" name={`question_${index+1}`} id={`question_${value['id']}`} value="3" onChange={() => handleCheckBoxClick(index,"question_"+value['id'],3)} />
                    <label class="form-check-label" for={`question_${index+1}`}>
                    <b>C:</b> {value['option_3']}
                    </label>
                  </div>
                  <div class="col-md-6 form-check pd-10">
                    <input class="form-check-input radio-size" type="radio" name={`question_${index+1}`} id={`question_${value['id']}`} value="4" onChange={() => handleCheckBoxClick(index,"question_"+value['id'],4)} />
                    <label class="form-check-label" for="flexRadioCheckedDisabled">
                    <b>D:</b> {value['option_4']}
                    </label>
                  </div>
                </div>
              </div>
           )
          })}
          {/* Question Group End */}
          </div>
          {questionData && questionData?.length > 0 ? (
            <div style={{'margin':'20px 20px 20px 20px'}} className="col-md-12 col-sm-5">
              <button className="btn btn-primary btn-success" onClick={() => handleTestSubmit(true)}>Submit Test</button>
            </div>
          ):<div><img src={Images?.NoData} alt="" width="100%" /></div>}
         </div>
        </div> 
        </Layout>
    );

};
export default TakeTest;